import React from "react";
import { REGISTER_URL } from "../../data/content";
import { Dot } from "./Section";

export default function FinalCTA({ testidTrial = "final-cta-trial" }) {
  return (
    <section className="final">
      <div className="wrap">
        <div className="final-card">
          <div>
            <h2>Try it on Monday<Dot /></h2>
            <p>Set up from your documents, film your first count and see your first order. 14 days free, no card, no sales call.</p>
          </div>
          <a className="btn" href={REGISTER_URL} data-testid={testidTrial}>Start free trial</a>
        </div>
      </div>
    </section>
  );
}
